import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  goBack: {
    defaultMessage: 'Go back',
    description: 'Label for the cancel button',
    id: 'frontend-app-ora.ConfirmDialog.goBack',
  },
});

export default messages;
